import { render, staticRenderFns } from "./Vedio_info.vue?vue&type=template&id=32850301&"
import script from "./Vedio_info.vue?vue&type=script&lang=js&"
export * from "./Vedio_info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports